import { SnackbarProgrammatic as Snackbar } from 'buefy'
import API from '@/api'
import router from '@/router'

const actions = {
  getCollection({ dispatch, commit, state }, payload) {
    API.hotels.getCollection(payload)
      .then(({ data: { data: { hasMore, results, hotelSearchId }, include, meta } }) => {
        if (!state.form.hotelSearchId) {
          commit('setField', {
            target: 'form.hotelSearchId',
            value: hotelSearchId
          })
        }

        commit('setCollection', results)

        if (hasMore && router.currentRoute.name === 'HotelsSearch') {
          dispatch('getCollection', {
            ...payload,
            hotelSearchId
          })
        } else {
          const {
            filters,
            minPrices
          } = include

          commit('setIsEmptySearchResult', !(results.length + state.collection.length))
          commit('setCollectionFilters', filters)
          commit('setMinPrices', minPrices)
          commit('setField', {
            target: 'form.hasMore',
            value: 0
          })
          commit('setField', {
            target: 'filters.priceFrom',
            value: include.filters.price.priceFrom
          })
          commit('setField', {
            target: 'filters.priceTo',
            value: include.filters.price.priceTo
          })
          commit('setField', {
            target: 'filters.distanceTo',
            value: include.filters.distance.maxDistance
          })
          commit('setIsLoading', false)
          commit('setIsFiltersDisabled', false)
        }

        commit('updatePagination', meta)
      })
      .catch(({ data: { errors } }) => {
        commit('setIsLoading', false)

        if (router.currentRoute.name === 'HotelsSearch') {
          commit('setErrors', errors)
          commit('setFormShowed', true)
          commit('setSearchShowed', false)
        }
      })
  },
  updateCollection({ commit }, payload) {
    API.hotels.getCollection(payload)
      .then(({ data: { data: { results }, meta } }) => {
        commit('setIsFiltersDisabled', false)

        if (meta.page === 1) {
          commit('setCollection', results)
        } else {
          commit('updateCollection', results)
        }

        commit('updatePagination', meta)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Не удалось загрузить список отелей',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('setIsLoading', false)
        commit('setIsUpdating', false)
        commit('setIsLoadingMore', false)
      })
  },
  addFavorite({ commit }, payload) {
    commit('updateIsFavoriteLoading', true)

    API.favorites.add(payload)
      .then(({ data: { data: { favoriteId } } }) => {
        commit('updateFavorite', {
          hotelId: payload.hotelId,
          favoriteId
        })
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Отель не был добавлен в избранноe.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateIsFavoriteLoading', false)
      })
  },
  removeFavorite({ commit }, { ids, hotelId }) {
    commit('updateIsFavoriteLoading', true)

    API.favorites.remove({ ids })
      .then(() => {
        commit('updateFavorite', {
          favoriteId: null,
          hotelId
        })
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Отель не был удален из избранного.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateIsFavoriteLoading', false)
      })
  }
}

export default actions